module.exports = __webpack_public_path__ + "static/media/james_wong_article_9.62cad7a9.jpg";